import React, { useState, useEffect, useRef } from "react";
import { SingleSelect, SingleSelectOption } from '@strapi/design-system/Select';
import { TextInput } from "@strapi/design-system/TextInput";
import { Box } from "@strapi/design-system/Box";
const RegulatoryExam = ({
  name,
  value,
  attribute,
  onChange,
  ...rest
}) => {
  const [regulatoryBodies, setRegulatoryBodies] = useState(undefined);
  const [regulatorySelected, setRegulatorySelected] = useState(null);
  const [data, setData] = useState({
    regulatoryBody: "",
    regulatoryId: ""
  });
  const didRegulatorySelectedChange = useRef(false);
  const strapiBackendURL = strapi?.backendURL.length ? strapi.backendURL : window.location.origin;
  useEffect(() => {
    initialValues();
  }, []);
  useEffect(() => {
    setNewDataObject();
  }, [regulatorySelected]);
  const getRegulatoryBodies = async () => {
    const fetchData = await fetch(strapiBackendURL + "/api/regulatory-bodies?populate=*");
    const data = await fetchData.json();
    setRegulatoryBodies(data.data);
    return data.data;
  };
  const initialValues = async () => {
    const regulatories = await getRegulatoryBodies();
    if (value) {
      const values = JSON.parse(value);
      const selectedRegulatory = regulatories.filter(reg => reg.id === values.regulatoryId);
      setData(values);
      setRegulatorySelected(selectedRegulatory);
    }
  };
  const setNewDataObject = async () => {
    if (didRegulatorySelectedChange.current && regulatorySelected) {
      const _data = {};
      const regulatoryTitle = regulatorySelected[0].attributes.title;
      const regulatoryId = regulatorySelected[0].id;
      regulatorySelected[0].attributes.regulatory_topic.forEach((topic, index) => {
        _data["topic_" + (index + 1)] = "";
      });
      setData({
        ["regulatoryBody"]: regulatoryTitle,
        ["regulatoryId"]: regulatoryId,
        ..._data
      });
      didRegulatorySelectedChange.current = false;
    }
  };
  const handleRegulatorySelect = id => {
    const selected = regulatoryBodies.filter(regulatory => regulatory.id === id);
    setRegulatorySelected(selected);
    didRegulatorySelectedChange.current = true;
  };
  const handleInputChange = (inputValue, inputId) => {
    const changeData = {
      ...data,
      [inputId]: inputValue
    };
    setData(changeData);
    onChangeTrigger(changeData);
  };
  const onChangeTrigger = dataChanged => {
    const dataToString = JSON.stringify(dataChanged);
    const dataTemplate = {
      target: {
        name,
        value: dataToString
      }
    };
    onChange(dataTemplate);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SingleSelect, {
    id: "select-regulatory-bodies",
    label: "Choose your regulatory body",
    required: true,
    placeholder: "Regulatory Bodies",
    value: regulatorySelected && (regulatorySelected[0].id || ""),
    onChange: handleRegulatorySelect
  }, regulatoryBodies && regulatoryBodies.map((item, index) => /*#__PURE__*/React.createElement(SingleSelectOption, {
    value: item.id,
    key: item?.attributes?.title
  }, item?.attributes?.title))), regulatorySelected && regulatorySelected[0].attributes?.regulatory_topic.map((topic, index) => /*#__PURE__*/React.createElement(Box, {
    padding: 4,
    key: topic.id
  }, /*#__PURE__*/React.createElement(TextInput, {
    key: topic.id,
    id: `topic_${index + 1}`,
    type: "number",
    min: 0,
    max: 100,
    placeholder: "Percentage ",
    label: topic.regulatory_topic,
    name: topic.regulatory_topic,
    onChange: e => handleInputChange(e.target.value, e.target.id),
    value: data[`topic_${index + 1}`] || ""
  }))));
};
export default RegulatoryExam;